import Path from "../../services/paths";
import ChannelSaleAction from "../actions/channelSaleAction";
import utils from "../common/utils";
import axios from "axios";


class GetChannelSaleMiddleware {
    static getChannelSale(
        selectedCategory,
        selectedBrand,
        selectedSku,
        selectedRegion,
        selectChannel,
        isValue
    ) {
        let url = `${Path.GET_CHANNEL_SALE}?`;
        if (Array.isArray(selectedCategory)) {
            selectedCategory.forEach(element => {
                url += `category=${element}&`;
            });
        }
        if (Array.isArray(selectedBrand)) {
            selectedBrand.forEach(element => {
                url += `brand=${element}&`;
            });
        }
        if (Array.isArray(selectedSku)) {
            selectedSku.forEach(element => {
                url += `master_sku=${element}&`;
            });
        }
        if (Array.isArray(selectedRegion)) {
            selectedRegion.forEach(element => {
                url += `region=${element}&`;
            });
        }
        if (Array.isArray(selectChannel)) {
            selectChannel.forEach(element => {
                url += `channel=${element}&`;
            });
        }
        if (isValue) {
            url += `is_value=${isValue}&`;
        } else {
            url += `is_value=${isValue}&`;
        }

        url = url.slice(0, -1);
        return dispatch => {
            dispatch(ChannelSaleAction.channelSaleRequest());
            utils
                .get_token()
                .then(token => {
                    axios({
                        method: "GET",
                        url: url,
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => {
                            if (res.error) {
                                // console.log("ERROR", res.error);
                            } else {
                                dispatch(
                                    ChannelSaleAction.channelSaleSuccessul(res)
                                );
                            }
                        })
                        .catch(error => {
                            // console.log("IN CATCH");
                            dispatch(ChannelSaleAction.channelSaleFailed(error));
                        });
                })
                .catch(error => {
                    dispatch(ChannelSaleAction.channelSaleRequest(error));
                });
        };
    }
}

export default GetChannelSaleMiddleware;
